import * as R from 'ramda';

import sportsApi from '../../utils/sportsApi';

const removeCollectionFromPost =
    store => async (state, clientId, postId, collectionId) => {
        const userClientId = state.user.selectedUserClientId;

        const payload = {
            action: 'remove',
            domainObject: {
                postIds: [postId],
            },
        };

        const result = await sportsApi
            .url(`/clients/${clientId}/collections/${collectionId}/posts`)
            .json(payload)
            .post()
            .res();

        if (result.status !== 204) {
            throw new Error('failed-to-remove-collection');
        }

        store.setState(
            R.evolve(
                {
                    clients: {
                        [userClientId]: {
                            media: {
                                posts: {
                                    [postId]: {
                                        collectionIds: R.without([
                                            collectionId,
                                        ]),
                                    },
                                },
                            },
                        },
                    },
                },
                store.getState(),
            ),
            true,
        );
    };

export default removeCollectionFromPost;
